const Mn = require('backbone.marionette');

module.exports = new (Mn.AppRouter.extend({
    initialize: function() {
        if (window.history && window.history.pushState) {
            $(document).on('click', '.push-state', e => {
                e.preventDefault();
                const url = $(e.currentTarget).attr('href');
                if (!url) {
                    return;
                }

                const [path, hash] = url.split('#');
                if(path) {
                    this.navigate(path, {trigger: true});
                }
                if(hash) {
                    location.hash = hash;
                }
            });
        }
    },
    routes: {
        '': 'user',
        'my/actions': 'myActions',
        'signup': 'signup',
        'invitation': 'invitation',
        'user-email-activate/:token': 'userEmailActivate',
        'accounts': 'account',
        'groups/:groupID': 'group',
        'groups/:groupID/roles': 'roleDashboard',
        'groups/:groupID/group-roles/:roleID': 'groupRole',
        'groups/:groupID/project-roles/:roleID': 'projectRole',
        'projects/:projectID': 'project',
        'projects/:projectID/processes': 'processDashboard',
        'projects/:projectID/processes/:processID': 'process',
        'projects/:projectID/processes/:processID/imports/:importRequestID': 'processImportRequest',
        'projects/:projectID/diagrams': 'diagramDashboard',
        'projects/:projectID/diagrams/:diagramID': 'diagram',
        'projects/:projectID/diagrams/:diagramID/diff': 'diagramDiff',
        'projects/:projectID/diagrams/:diagramID/imports/:importRequestID': 'diagramImportRequest',
        'projects/:projectID/data-contents': 'dataContentDashboard',
        'projects/:projectID/data-contents/:contentID': 'dataContent',
        'feedbacks': 'feedbacks',
        'feedbacks/': 'feedbacks',
        'feedbacks/:feedbackID': 'feedback',
        'feedback/ideas': 'ideas',
        'feedback/ideas/:ideaID': 'idea',
        'feedback/announcements': 'announcements',
        'feedback/announcements/:announcementID': 'announcement',
        'feedback/admin/ideas': 'ideasAdmin',
        'feedback/admin/ideas/:ideaID': 'ideaAdmin',
        'feedback/admin/ideas/:ideaID/edit': 'ideaEdit',
        'feedback/admin/announcements': 'announcementsAdmin',
        'feedback/admin/announcements/:announcementID': 'announcementAdmin',
    },

    user: function() {
        this.trigger('user');
    },

    myActions: function() {
        this.trigger('myActions');
    },

    signup: function() {
        this.trigger('signup');
    },

    invitation: function() {
        this.trigger('invitation');
    },

    userEmailActivate: function(token) {
        this.trigger('userEmailActivate', token);
    },

    account: function() {
        this.trigger('account');
    },

    group: function(groupID) {
        this.trigger('group', groupID);
    },

    roleDashboard: function(groupID) {
        this.trigger('roleDashboard', groupID);
    },

    groupRole: function(groupID, roleID) {
        this.trigger('groupRole', groupID, roleID);
    },

    projectRole: function(groupID, roleID) {
        this.trigger('projectRole', groupID, roleID);
    },

    project: function(projectID) {
        this.trigger('project', projectID);
    },

    processDashboard: function(projectID) {
        this.trigger('processDashboard', projectID);
    },

    process: function(projectID, processID) {
        this.trigger('process', projectID, processID);
    },

    processImportRequest: function(projectID, processID, importRequestID) {
        this.trigger('processImportRequest', projectID, processID, importRequestID);
    },

    diagramDashboard: function(projectID) {
        this.trigger('diagramDashboard', projectID);
    },

    diagram: function(projectID, diagramID) {
        this.trigger('diagram', projectID, diagramID);
    },

    diagramImportRequest: function(projectID, diagramID, importRequestID) {
        this.trigger('diagramImportRequest', projectID, diagramID, importRequestID);
    },

    diagramDiff: function(projectID, diagramID) {
        this.trigger('diagramDiff', projectID, diagramID);
    },

    dataContentDashboard: function(projectID) {
        this.trigger('dataContentDashboard', projectID);
    },

    dataContent: function(projectID, contentID) {
        this.trigger('dataContent', projectID, contentID);
    },

    ideas: function() {
        this.trigger('feedback:ideas');
    },

    idea: function(ideaID) {
        this.trigger('feedback:idea', ideaID);
    },

    ideasAdmin: function() {
        this.trigger('feedback:admin:ideas');
    },

    ideaAdmin: function(ideaID) {
        this.trigger('feedback:admin:idea', ideaID);
    },

    ideaEdit: function(ideaID) {
        this.trigger('feedback:admin:idea:edit', ideaID);
    },

    announcements: function() {
        this.trigger('feedback:announcements');
    },

    announcementsAdmin: function() {
        this.trigger('feedback:admin:announcements');
    },

    announcement: function(announcementID) {
        this.trigger('feedback:announcement', announcementID);
    },

    announcementAdmin: function(announcementID) {
        this.trigger('feedback:admin:announcement', announcementID);
    },

    navigateProject: function(project) {
        this.navigate(`projects/${project.id}`, {trigger: true});
    },

    navigateProcessDashboard: function(project) {
        this.navigate(`projects/${project.id}/processes`, {trigger: true});
    },

    navigateProcess: function(project, process) {
        this.navigate(`projects/${project.id}/processes/${process.id}`, {trigger: true});
    },

    navigateProcessImport: function(project, process, importID) {
        this.navigate(`projects/${project.id}/processes/${process.id}/imports/${importID}`, {trigger: true});
    },

    navigateDataContentDashboard: function(project) {
        this.navigate(`projects/${project.id}/data-contents`, {trigger: true});
    },

    navigateDiagramDashboard: function(projectID) {
        this.navigate(`projects/${projectID}/diagrams`, {trigger: true});
    },

    navigateDiagramImport: function(project, diagramID, importID) {
        this.navigate(`projects/${project.id}/diagrams/${diagramID}/imports/${importID}`, {trigger: true});
    },
}))();



// WEBPACK FOOTER //
// ./balus/app/router/index.js